import React from "react";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store/store"; // Correct import for store and persistor
import "./index.css";
import { AuthProvider } from "./auth/authContext";
import AppRouter from "./appRouter";

// UNIVERSAL VERSION CHECK - runs regardless of routing
console.log('🔥 INDEX.JS LOADED!');
console.log('🔥 Starting universal version check...');

// Version checking handled by VersionManager - removed duplicate check

const root = createRoot(document.getElementById("root"));

root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter>
                <AuthProvider>
                    <AppRouter />
                </AuthProvider>
            </BrowserRouter>
        </PersistGate>
    </Provider>
);
